import React from 'react';

const NoDataDisplay = () => {
  return (
    <div className="noData">
      <div className="noDataText">No data available at this time.</div>
    </div>
  );
};

export default NoDataDisplay;
